var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-redactor" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm.message
        ? _c(
            "v-alert",
            {
              staticStyle: {
                "margin-top": "50px",
                "margin-left": "50%",
                left: "-10%",
              },
              attrs: { type: "error", width: "20%" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c(
                "v-layout",
                { staticStyle: { width: "256px" } },
                [
                  _c(
                    "vue-perfect-scrollbar",
                    { staticClass: "scrollbar" },
                    [
                      _c("menu-view", {
                        attrs: {
                          "name-game": _vm.nameGame,
                          "name-config": _vm.nameConfig,
                          readonly: _vm.readonly,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-layout",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "vue-perfect-scrollbar",
                    { staticClass: "scrollbar" },
                    [_c("router-view", { key: _vm.routeViewKey })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }